
import { ITrainerBioRes } from '../../models/trainerbio.model';
import deleteService from '../deleteService';
import getService from '../getService';
import postService from '../postService';

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const COURSERESOURCE = 'courses/'
const DELETERESOURCE ='course-resources/'

class TrainerResourseService {
  
  async getCourseResources(uuid: string) {
    const response = await getService.get(`${CONFIG_API_URL}${COURSERESOURCE}${uuid}/resources`)
    const res :any = response.data
    return res;
  }
  async createCourseResource(data: any, uuid: string) {
    const response = await postService.post(`${CONFIG_API_URL}${COURSERESOURCE}${uuid}/resources`, data)
    const res :any = response.data
    return res;
  }
  async deleteCourseResource(uuid: string) {
    const response = await deleteService.delete(`${CONFIG_API_URL}${DELETERESOURCE}${uuid}`)
    const res :any = response.data
    return res;
  }
  
  
 
}

export default new TrainerResourseService();